import { render, staticRenderFns } from "./FilaContrato.vue?vue&type=template&id=3c5c8870&scoped=true&"
import script from "./FilaContrato.vue?vue&type=script&lang=js&"
export * from "./FilaContrato.vue?vue&type=script&lang=js&"
import style0 from "./FilaContrato.vue?vue&type=style&index=0&id=3c5c8870&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c5c8870",
  null
  
)

export default component.exports